<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="onSorted"
    @on-cancel="hide()"
    :okText="$t('Sort')"
    :closeText="$t('Close')"
  >
    <div v-for="item in sortItems" :key="item.uuid">
      <v-row>
        <v-col cols="2" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                tile
                color="error"
                icon
                large
                @click="removeSort(item.uuid)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Remove") }}</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete
            v-model="item.fieldTitle"
            v-bind:label="$t('Field')"
            :items="getFieldTitles()"
          ></v-autocomplete>
        </v-col>

        <v-col cols="4">
          <v-radio-group v-model="item.sortOrder" row>
            <v-radio value="asc">
              <template v-slot:label>
                <div>
                  <v-icon>mdi-sort-alphabetical-ascending</v-icon>
                </div>
              </template>
            </v-radio>
            <v-radio value="desc">
              <template v-slot:label>
                <div>
                  <v-icon>mdi-sort-alphabetical-descending</v-icon>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>

        <!-- <v-col cols="1" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" tile large color="blue darken-4" icon @click="addSort()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Add')}}</span>
          </v-tooltip>
        </v-col> -->
      </v-row>
      <!-- <v-subheader v-if="!isLastSort(item.uuid)">---THEN BY---</v-subheader> -->
    </div>
  </base-modal>
</template>
<script>
import SortItem from "@/ecm/models/search/SortItem";
export default {
  name: "SortModal",
  props: {
    fieldList: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.addSort();
  },
  data() {
    return {
      modal: {
        title: this.$t("Sort"),
        key: "sortModal"
      },
      open: false,
      sortItems: []
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    }
  },
  methods: {
    getFieldTitles() {
      if (this.fieldList || this.fieldList.length > 0) {
        return Array.from(new Set(this.fieldList.map(f => f.Title)));
      } else {
        return [];
      }
    },
    addSort() {
      this.sortItems.push(new SortItem());
    },
    removeSort(uuid) {
      this.sortItems = this.sortItems.filter(item => item.uuid !== uuid);
      if (this.sortItems.length == 0) {
        this.addSort();
      }
    },
    onSorted() {
      if (this.sortItems.length == 1 && this.sortItems[0].fieldTitle == "")
        this.$emit("on-sorted", []);
      else this.$emit("on-sorted", this.sortItems);
      this.hide();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
    isLastSort(uuid) {
      if (this.sortItems.length <= 1) return true;
      return this.sortItems[this.sortItems.length - 1].uuid == uuid;
    }
  }
};
</script>
